<template>
  <div class="inputer-select" :class="{ disabled: disabled }">
    <div class="selector" :class="{ show: showed }">
      <div v-if="item_new" class="new">
        <button @click="add" title="Přidat">
          <i class="fa fa-plus" />
        </button>
      </div>
      <div v-if="item_null" class="item" @click="change(null)">{{ empty }}</div>
      <div v-for="(item, key) in items_object" :key="key" class="item" @click="change(getKey(item, key))">
        <slot name="item" :item="item" :id="key">{{ item }}</slot>
      </div>
    </div>
    <div class="label" @click="toggle">
      <slot :label="label" :id="value" :item="items_object[value]">{{ label }}</slot>
    </div>
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { events } from "../extend";

export default {
  name: "inputer-select",
  props: {
    items: { default: {} },
    paths: { default: null },
    disabled: { default: false },
    item_new: { default: false },
    item_null: { default: false },
    empty: { default: "Žádný" },
    new_action: { default: null },
    confirmation: { default: null },
    getKey: { default: () => (item, key) => key }
  },
  data: () => ({
    showed: false
  }),
  computed: {
    items_object() {
      if (Array.isArray(this.items)) {
        var result = {};
        this.items.forEach(item => {
          Vue.set(result, item, item);
        });

        return result;
      }

      return this.items;
    },
    value() {
      return this.paths != null ? this.$store.getters.getAt(this.paths) : null;
    },
    label() {
      return this.items_object[this.value] != null
        ? this.items_object[this.value]
        : this.empty;
    },
    changed() {
      return this.paths != null && this.$store.getters.isChangedAt(this.paths);
    }
  },
  methods: {
    add() {
      if (this.new_action != null) this.new_action();
      this.hide();
    },
    change(value) {
      if (this.confirmation && !confirm(this.confirmation)) {
        this.hide();
        return;
      }

      if (this.paths != null) {
        this.$store.commit("update", {
          paths: this.paths,
          value: value
        });
      }
      this.$emit('change', { value });
      this.hide();
    },
    show() {
      this.showed = true;
    },
    hide() {
      this.showed = false;
    },
    toggle() {
      if (this.disabled) this.showed = false;
      else this.showed = !this.showed;
    }
  },
  mounted() {
    events.closer(this.$el, this.hide);
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.inputer-select
  @include inputer-select()
</style>
